import { Link } from "react-router-dom";
import { BrandMark, BrandWordmark } from "./BrandLogo";
import { BRAND } from "../lib/config";

const footerLink = "hover:text-foreground transition-colors rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]";

export const SiteFooter = () => (
  <footer className="border-t border-border bg-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-1.5 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] focus-visible:ring-offset-2" aria-label="EnquiryOps home">
          <BrandMark size={28} />
          <div>
            <BrandWordmark className="text-sm block leading-tight" />
            <p className="text-xs text-muted-foreground">{BRAND.tagline}</p>
          </div>
        </Link>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-muted-foreground">
          <a href="/#pricing" className={footerLink}>Pricing</a>
          <a href="/#faq" className={footerLink}>FAQ</a>
          <Link to="/demo" className={footerLink} data-testid="footer-demo-link">Demo</Link>
        </div>
      </div>
      <div className="mt-6 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <Link to="/privacy-policy" className={footerLink} data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/terms-of-service" className={footerLink} data-testid="footer-terms-link">Terms of Service</Link>
          <Link to="/anti-spam-policy" className={footerLink} data-testid="footer-antispam-link">Anti-Spam Policy</Link>
        </div>
        <span>© {new Date().getFullYear()} EnquiryOps · Singapore</span>
      </div>
    </div>
  </footer>
);
